module.exports = __webpack_public_path__ + "e818fa543852bac26bc5639a007afce5.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/Anymag_logo.svg
// module id = 284
// module chunks = 0